<template>
  <HomeJumbotron />
  <div class="w-full bg-primary">
    <p class="text-center text-white py-4">
      <b>Wichtiger Hinweis:</b> Unsere Circus-Vorstellungen finden bei jeder
      Witterung statt!
    </p>
  </div>
  <div class="pt-8 lg:pt-16 mb-4">
    <NewsList :length="3" />
  </div>
  <div class="flex justify-center">
    <NuxtLink
      to="/news"
      class="button mb-16 flex items-center justify-center gap-2"
      data-umami-event="news_link_clicked"
    >
      <NewspaperIcon class="w-4 h-4 ml-2" />
      <span>Mehr Neuigkeiten</span>
    </NuxtLink>
  </div>
  <!-- <PresaleHighlights /> -->
  <hr />
  <HomeAbout />
  <hr />

  <GalleryCarousel class="!pb-8 px-4 md:px-12" />
  <div class="flex justify-center">
    <NuxtLink
      to="/gallery"
      class="button mb-16 flex items-center justify-center gap-2"
      data-umami-event="gallery_link_clicked"
    >
      <ImageIcon class="w-4 h-4 ml-2" />
      <span>Mehr Bilder ansehen</span>
    </NuxtLink>
  </div>
  <hr />
  <HomeArrival />
  <hr />
  <HomeContact />
</template>

<script setup lang="ts">
import { ImageIcon, NewspaperIcon } from "lucide-vue-next";

useHead({
  title: "Circus St. Ottilien",
});
</script>
